import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { NavBar } from '../../components/layout/NavBar';
import './Login.module.css'
import { Services } from '@/services/services';
import { Machine } from '@/services/model/machine';
import { Translates } from '@/services/repository/i18n';
import { SubmitHandler, useForm } from 'react-hook-form';
import { LoginForm, FormData, FormErrors } from './Login.form';
import { callMeBtn } from '@/components/Elements/CallMeBtn';
import { MainLayout } from '@/components/layout/MainLayout';
import { useLogin } from '@/context/login';
import { CommunalHeader } from '@/components/layout/CommunalHeader';

export const LoginPage = ({ services }: { services: Services }) => {
  const navigate = useNavigate()
  const [data, setData] = useState<FormData>()
  const [translates, setTranslates] = useState<Translates>()
  const [message, setMessage] = useState<string>()
  const [serverErrors, setServerErrors] = useState<FormErrors<FormData>>()
  const { goBackAfterLogin } = useLogin()

  if (services.session.isLoggedIn()) {
    navigate('/dashboard')
  }

  const form = useForm<FormData>({
    defaultValues: data
  })

  const onSubmit = async (data: FormData, resetForm: () => void) => {
    setMessage(undefined)
    services.session.login(data).then((data) => {
      // resetForm()
      goBackAfterLogin()
    }).catch((error) => {
      setMessage('page.login.loginError')
      setTimeout(() => setMessage(''), 5000)
    })
    // const resp = await fetch(`/api/schema/machines/byid/${mid}/update`, {
    //   method: 'PUT',
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify(data)
    // })
    // if (!resp.ok) {
    //   setServerErrors(await resp.json())
    // } else {
    //   // services.machines.list().then((data) => setData(data))
    //   // resetForm()
    //   setMessage('page.machine.updatedMessage')
    //   setTimeout(() => setMessage(''), 5000)
    // }
  }

  useEffect(() => {
    services.i18n.get('main').then(setTranslates)
  }, [])


  if (translates === undefined) {
    return (<div className='spinner'></div>)
  }

  return <MainLayout services={services} translates={translates} pageName='login'>
    <CommunalHeader services={services} translates={translates} pageId='login' />
    <div className='main-form main-form-single-col'>
      {/* <div className='form-title'>{translates.for('page.login.formTitle')}</div> */}
      <LoginForm
        form={form}
        services={services}
        onSubmit={onSubmit}
        serverErrors={serverErrors}
      />
      {message ? (<div className='form-message'>{translates.for(message)}</div>) : null}


      {/* <a className='main-btn' onClick={() => navigate(`/registration`)}>
        {translates?.for('page.login.registration')}
      </a>
      <a className='main-btn' onClick={() => navigate(`/resetpassword`)}>
        {translates?.for('page.login.resetpassword')}
      </a> */}

      <div className='support-wrap' onClick={() => navigate('/communal/support/wizard')}>
        {translates?.for('layout.support_page')}
      </div>
    </div>
  </MainLayout>
}
